import React, { useEffect, useState } from 'react';
import RecipientFilterContainer from './RecipientFilterContainer';
import "./RecipientFilterOverlay.scss";
import { Breadcrumb, BreadcrumbItem } from '@livingdesign/react';
import EditFormActionsFooter from '../../EditFormActionsFooter';
import AlertModal from '../../../../../common/AlertModal/AlertModal';
import { useRecipientFilter } from '../../../../../../../contexts/RecipientFilter';
import RecipientFilterReviewModal from './RecipientFilterReviewModal';
import { ACTIONS } from '../../../../../../../consts/CommonV2';

export const QA_ID_PREFIX = "RecipientFilterOverlay";

function RecipientFilterOverlay({
    open,
    handleClose,
    onApplyCallback,
    loading,
    defaultFilter = {},
    mode=ACTIONS.CAMPAIGN_PAGE,
    navMenu,
    onSuccessUpdate
}) {

    const {
        alertMessage,
        setAlertMessage,
        parsedFilter,
        recipientCount,
        saveNewFilter,
        updateFilter,
        filterName,
        setFilterName,
        filterId,
        isValid,
        generateRawFilter,
    } = useRecipientFilter();

    const [currentStep, setCurrentStep] = useState(0);
    const [steps, setSteps] = useState([]);
    const [showActionsFooter, setShowActionsFooter] = useState(false);
    const [showFilterReviewModal, setShowFilterReviewModal] = useState(false);

    useEffect(() => {
        if(!open) return;
        const steps = [
            {
                title: "Recipient Filtering",
                component: <RecipientFilterContainer />,
            }
        ];
        setSteps(steps);
        setCurrentStep(0);
    }, [open]);

    const handleOpenReview = () => {
        if(!isValid) {
            setAlertMessage({
                show: true,
                title: "Invalid filter",
                message: "Please fill all the filter conditions before proceeding.",
                cancelButtonText: "Cancel",
                confirmButtonText: "Ok",
                handleConfirm: () => setAlertMessage({ ...alertMessage, show: false }),
                handleClose: () => setAlertMessage({ ...alertMessage, show: false }),
            })
            return;
        }
        setShowFilterReviewModal(true);
    }

    if(!open) return null;
    return (
        <div className='recipient-filter-overlay' data-testid={`${QA_ID_PREFIX}-overlay`}>
            <div className='recipient-filter-main' data-testid={`${QA_ID_PREFIX}-container`}>
                {

                    mode === ACTIONS.CAMPAIGN_PAGE ?
                        (
                            <Breadcrumb data-testid={`${QA_ID_PREFIX}-breadcrumb`}>
                                <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-home`}>Home</BreadcrumbItem>
                                <BreadcrumbItem
                                    onClick={async () => {
                                        handleClose();
                                    }}
                                    data-testid={`${QA_ID_PREFIX}-breadcrumb-create-message`}
                                    UNSAFE_style={{cursor: 'pointer'}}
                                >
                                    Create new message
                                </BreadcrumbItem>
                                <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-csv-upload`}>Recipient Filtering</BreadcrumbItem>
                            </Breadcrumb>
                        ) :
                        (navMenu)
                }
                
                <div data-testid={`${QA_ID_PREFIX}-step-content`}>
                    {steps.length > 0 && steps[currentStep].component}
                </div>
                <section style={{paddingBottom: "120px"}} data-testid={`${QA_ID_PREFIX}-actions-footer-section`}>
                    <EditFormActionsFooter
                        loading={loading}
                        disableContinue={false}
                        onPrevious={() => {
                            if(currentStep === 0) {
                                handleClose();
                            }
                        }}
                        onSaveDraft={async () => {
                            if (filterId) {
                                await updateFilter();
                            } else {
                                handleOpenReview();
                            }
                        }}
                        onContinue={async () => {
                            handleOpenReview();
                        }}
                        data-testid={`${QA_ID_PREFIX}-actions-footer`}
                    />
                </section>
            </div>
            <AlertModal
                show={alertMessage?.show}
                handleClose={() => setAlertMessage({ ...alertMessage, show: false })}
                title={alertMessage?.title}
                message={alertMessage?.message}
                cancelButtonText={alertMessage?.cancelButtonText}
                confirmButtonText={alertMessage?.confirmButtonText}
                handleConfirm={alertMessage?.handleConfirm}
                data-testid={`${QA_ID_PREFIX}-alert-modal`}
            />
            <RecipientFilterReviewModal
                isOpen={showFilterReviewModal}
                onClose={() => {
                    setShowFilterReviewModal(false);
                }}
                parsedFilter={parsedFilter}
                recipientsCount={recipientCount}
                filterName={filterName}
                setFilterName={setFilterName}
                filterId={filterId}
                updateFilter={updateFilter}
                saveNewFilter={saveNewFilter}
                handleApplyFilters={async () => {
                    const rawFilter = generateRawFilter(parsedFilter);
                    await onApplyCallback({ filterName, rawFilter, recipientCount});
                    setShowFilterReviewModal(false);
                }}
                mode={mode}
                onSuccessUpdate={() =>{
                    const rawFilter = generateRawFilter(parsedFilter);
                    setShowFilterReviewModal(false);
                    onSuccessUpdate({ filterName, rawFilter, recipientCount });
                }}
                data-testid={`${QA_ID_PREFIX}-review-modal`}
            />
        </div>
    )
}

export default RecipientFilterOverlay;